export const DELETE = 'Удалить';
export const CREATE = 'Создать';
export const SAVE = 'Сохранить';
export const CLEAR_FILTERS = 'Очистить фильтры';
export const CANCEL = 'Отмена';
